import { render, staticRenderFns } from "./FormField.vue?vue&type=template&id=53c31de6&scoped=true&"
import script from "./FormField.vue?vue&type=script&lang=js&"
export * from "./FormField.vue?vue&type=script&lang=js&"
import style0 from "./FormField.vue?vue&type=style&index=0&id=53c31de6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c31de6",
  null
  
)

export default component.exports